import { Box, Card, CardContent, Grid, MenuItem, Select, Typography } from '@mui/material'
import React from 'react'
import { DELIBERATION_PENDING, DRAFT, FROZEN, INCOMPLETE, PUBLISHED, TRANSFERRED_SYSPEA, VALIDATED, VERIFIED_DDTM } from 'rpqs/constants/RpqsConstant'
import i18n from 'simple-react-i18n'
import PropTypes from 'prop-types'
import CircleIcon from '@mui/icons-material/Circle'
import { CardTitle } from 'components/card/NewCard'

const StatusPanel = ({
    status = INCOMPLETE,
}) => {
    const handleRenderValue = (selectedStatus) => {
        const { color, name } = selectedStatus || INCOMPLETE

        return (
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                }}
            >
                <CircleIcon
                    fontSize='small'
                    sx={{
                        color,
                    }}
                />
                <Typography>{i18n[name]}</Typography>
            </Box>
        )
    }

    return (
        <Card>
            <CardTitle title={i18n.generalAdvancementStatus} />
            <CardContent>
                <Grid container>
                    <Grid size={12}>
                        <Select
                            defaultValue={status}
                            fullWidth
                            renderValue={handleRenderValue}
                            sx={{
                                '.MuiSelect-outlined': {
                                    py: 1/2,
                                    px: 1,
                                },
                            }}
                        >
                            <MenuItem value={VALIDATED}>{i18n[VALIDATED.name]}</MenuItem>
                            <MenuItem value={INCOMPLETE}>{i18n[INCOMPLETE.name]}</MenuItem>
                            <MenuItem value={DRAFT}>{i18n[DRAFT.name]}</MenuItem>
                            <MenuItem value={PUBLISHED}>{i18n[PUBLISHED.name]}</MenuItem>
                            <MenuItem value={FROZEN}>{i18n[FROZEN.name]}</MenuItem>
                            <MenuItem value={DELIBERATION_PENDING}>{i18n[DELIBERATION_PENDING.name]}</MenuItem>
                            <MenuItem value={VERIFIED_DDTM}>{i18n[VERIFIED_DDTM.name]}</MenuItem>
                            <MenuItem value={TRANSFERRED_SYSPEA}>{i18n[TRANSFERRED_SYSPEA.name]}</MenuItem>
                        </Select>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    )
}

StatusPanel.propTypes = {
    setEntity: PropTypes.func,
    status: PropTypes.shape({
        name: PropTypes.string,
        color: PropTypes.string,
        bgColor: PropTypes.string,
    }),
    year: PropTypes.string,
}

export default StatusPanel
